export const insuranceCardDocumentationMarkdown = `
# Insurance Card

This block takes an insurance card image and extracts the relevant information.

## Configuration

- Cloud storage path: path to the insurance card image.
`;
